import React from "react"
import styled from "styled-components"
import { Line, LineProps } from "../../atoms/line"

export type MultiLinesProps = {
  lines: LineProps[]
  className?: string
  dataCy: string
}

export const MultiLines = (props: MultiLinesProps) => {
  const { lines, dataCy, className } = props

  return (
    <Root className={className} data-cy={dataCy}>
      {lines.map((line, index) => {
        return <Line key={`line-${index}`} {...line} />
      })}
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
`
